import { isiOSApp } from '@lean-body/src/util';
import axios from 'axios';
import { ASPServerError } from '../errors';
/**
 * 埋め込みタグ群を挿入するクラス
 * 埋め込みだけが目的のタグをここに集約させています。
 * GoogleAnalyticsなど、埋め込んだ後に何か処理をする必要があるものは別なクラスにしています。
 */
export class TagClient {
    constructor(config, userID) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.userId = userID;
        this.axios = axios.create();
        this.embedGlobalTags();
        this.axios.interceptors.response.use((res) => {
            // 何もしない
            return res;
        }, (error) => {
            this.onError(error);
        });
    }
    /*
     * グローバルタグ
     */
    embedGlobalTags() {
        // iOS(webview)でgtmの読み込みエラーが発生すると表示が遅くなったりするバグがあるので対象から外す
        // localhostはエラーになるので外す
        if (isiOSApp() || !this.config.isProdOrStg)
            return;
        this.embedGoogleTagManager();
        this.embedGoogleOptimize();
    }
    // Googleタグマネージャ
    embedGoogleTagManager() {
        const ad = document.createElement('div');
        ad.id = 'google_tag_manager';
        ad.innerHTML = `<!-- Global site tag (gtag.js) - Google Ads: 822881874 --> <script async src=“https://www.googletagmanager.com/gtag/js?id=AW-822881874“></script> <script> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag(‘js’, new Date()); gtag(‘config’, ‘AW-822881874’); </script>`;
        const gtmHead = document.createElement('script');
        gtmHead.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${this.config.gtmId}');
        `;
        const gtmBody = document.createElement('noscript');
        gtmBody.innerHTML = `
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${this.config.gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        `;
        document.getElementsByTagName('head')[0].appendChild(ad);
        document.getElementsByTagName('head')[0].appendChild(gtmHead);
        document.getElementsByTagName('head')[0].appendChild(gtmBody);
    }
    // GoogleOptimyieグローバルタグ(あえてpublic)
    embedGoogleOptimize() {
        const gTagLink = document.createElement('script');
        gTagLink.src = `https://www.googletagmanager.com/gtag/js?id=${this.config.gaId}`;
        gTagLink.async = true;
        const gTagConfig = document.createElement('script');
        gTagConfig.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${this.config.gaId}', {
              send_page_view: false
            });
        `;
        document.head.appendChild(gTagLink);
        document.head.appendChild(gTagConfig);
    }
    trackView() {
        window.gtag &&
            window.gtag('config', this.config.gaId, {
                page_title: window.location.pathname,
                page_location: window.location.href,
                user_id: this.userId,
            });
    }
    trackClick(category, label, value) {
        window.gtag &&
            window.gtag('event', 'click', {
                page_title: window.location.pathname,
                page_location: window.location.href,
                event_category: category,
                event_label: label,
                value: value,
                user_id: this.userId,
            });
    }
    trackSlide(category, label, value) {
        window.gtag &&
            window.gtag('event', 'slide', {
                page_title: window.location.pathname,
                page_location: window.location.href,
                event_category: category,
                event_label: label,
                value: value,
                user_id: this.userId,
            });
    }
    // Sign in with Apple JS のスクリプトを埋め込み
    embedAppleScript() {
        const script = document.createElement('script');
        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ja_JP/appleid.auth.js';
        script.async = true;
        const onScriptError = () => {
            console.log('onScriptError');
        };
        script.addEventListener('error', onScriptError);
        document.body.appendChild(script);
    }
    onError(error) {
        const e = error;
        if (!e.response) {
            throw e;
        }
        const data = e.response.data;
        if (data.displayMessage) {
            throw new ASPServerError(e.message, data.displayMessage);
        }
        throw error;
    }
}
